import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for PIPE_FAMILIES
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'pipeFamily',
  plural: 'pipeFamilies',
  state: 'pipeFamilies'
};
